import { render } from "./VulnReports.vue?vue&type=template&id=044273e4"
import script from "./VulnReports.vue?vue&type=script&lang=js"
export * from "./VulnReports.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__